// extracted by mini-css-extract-plugin
export default {"ProjectMetricCards":"ProjectMetricCards_ProjectMetricCards__L9TKY"};